import { DatePipe } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Context } from 'src/app/shared/models/context';
import { EmployeeData, Message } from 'src/app/shared/models/domain';
import { ExitClearance, Separation } from 'src/app/shared/models/separation';
import { AuthService } from 'src/app/shared/services/auth.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { CompanyService } from 'src/app/shared/services/company.service';
import { SeparationService } from 'src/app/shared/services/separation.service';
import { Observable, throwError } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';

@Component({
  selector: 'app-exit-clearance',
  templateUrl: './exit-clearance.component.html',
  styleUrls: ['./exit-clearance.component.scss']
})
export class ExitClearanceComponent implements OnInit {
  @Input() context: Context;
  @Input() separation: Separation;
  @Input() separationId: number;

  public exitClearance: ExitClearance;
  public exitClearances: ExitClearance[]=[];
  public exitClearanceForm: FormGroup;
  public submitted: boolean = false;
  private modified: boolean = false;
  public statuses: string;
  public selectedClearance:any;

  constructor(
    private separationService: SeparationService,
    private commonService: CommonService,
    private fb: FormBuilder,
    private companyService: CompanyService,
    private authService: AuthService,
    private datePipe: DatePipe,
  ) { }

  ngOnInit(): void {
    this.context = this.authService.getContextData();
    this.setExitClearence(this.exitClearance);
    this.separationService.getExitSatus().subscribe(statuses=> (this.statuses = statuses));
    this.getExitClearance();
  }

  public getExitClearance(){
    if (this.separationId) {
      this.separationService.getExitClearances(this.separationId).subscribe(exitClearances => {
        if (exitClearances.length) {
          this.selectedClearance = exitClearances[0];
          this.exitClearanceForm.patchValue({
            assertReturned: this.selectedClearance.assertReturned,
            hrVerified: this.selectedClearance.hrVerified,
            adminVerified: this.selectedClearance.adminVerified,
            date: this.selectedClearance.date ? this.datePipe.transform(this.selectedClearance.date, 'yyyy-MM-dd'): null,
            status: this.selectedClearance.status,
          }); 
        }
      });
    }
  }

  public setExitClearence(exitClearance?: ExitClearance) {
    if (!exitClearance)
      exitClearance = {
        id: null,
        date: null,
        status: null,
        assertReturned: false,
        hrVerified: false,
        adminVerified: false,
        disabled: false,
        separationId: this.separationId,
        employeeName: null,
      } as ExitClearance;
    this.exitClearanceForm = this.fb.group({
      id: this.fb.control(exitClearance.id, []),
      date: this.fb.control(this.datePipe.transform(new Date(), 'yyyy-MM-dd')),
      status: this.fb.control(exitClearance.status, [Validators.required]),
      assertReturned: this.fb.control(exitClearance.assertReturned, []),
      hrVerified: this.fb.control(exitClearance.hrVerified, []),
      adminVerified: this.fb.control(exitClearance.adminVerified, []),
      disabled: this.fb.control(exitClearance.disabled, []),
      separationId: this.fb.control(exitClearance.separationId, [Validators.required]),
      employeeName: this.fb.control(exitClearance.employeeName, []),
    });
    this.exitClearanceForm.valueChanges.subscribe(value => this.modified = true);
  }

  get s() {
    return this.exitClearanceForm.controls;
  }

  // public saveExitClearance() {
  //   this.submitted=true;
  //   this.exitClearanceForm.markAllAsTouched();
  //   if (this.exitClearanceForm.valid) {
  //     const exitClearance = this.exitClearanceForm.value as ExitClearance;
  //     this.separationService.createExitClearance(exitClearance).subscribe({
  //       next: (response: Message) => {
  //         if (!response.failed) {
  //           this.commonService.setToastr(200, `Exit Clearence has been created successfully!`);
  //         } else {
  //           this.commonService.setToastr(500, 'Unable to complete the action. Please try again.');
  //         }
  //       },
  //       error: (error: HttpErrorResponse) => {
  //         this.commonService.setToastr(500, error?.error?.name || error.error);
  //       },
  //     });
  //   }
  // }

  public saveExitClearance(): Observable<Message> | void {
    this.submitted = true;
    this.exitClearanceForm.markAllAsTouched();
  
    if (this.exitClearanceForm.valid) {
      const exitClearance = this.exitClearanceForm.value as ExitClearance;
  
      return this.separationService.createExitClearance(exitClearance).pipe(
        tap((response: Message) => {
          if (!response.failed) {
            this.commonService.setToastr(200, `Exit Clearance has been created successfully!`);
          } else {
            this.commonService.setToastr(500, 'Unable to complete the action. Please try again.');
          }
        }),
        catchError((error: HttpErrorResponse) => {
          this.commonService.setToastr(500, error?.error?.name || error.error);
          return throwError(() => error);
        })
      );
    }
  }
  
}



